module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_telephone-399e3b6f97e35b2e1f2acfc2092ee552.svg";